import {
  baseUniDriverFactory,
  findByHookAtIndex,
} from '../utils/test-utils/unidriver';
import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import { dataHooks } from './constants';

import { BaseUniDriver, UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface StackedBarChartUniDriver extends BaseUniDriver {
  /**
   * Gets number of tooltips.
   */
  getDataLength: () => Promise<number>;
  /**
   * Gets tooltip value at index.
   */
  getTooltipContentAt(index: number): Promise<any>;
}

export const stackedBarChartDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): StackedBarChartUniDriver => {
  return {
    ...baseUniDriverFactory(base),

    getDataLength: async () => {
      return base.$$(`[data-hook="${dataHooks.tooltip}"]`).count();
    },

    getTooltipContentAt: async index => {
      const tooltipElement = await findByHookAtIndex(
        base,
        dataHooks.tooltip,
        index,
      );
      const tooltipTestkit = tooltipDriverFactory(tooltipElement, body);

      return await tooltipTestkit.getTooltipText();
    },
  };
};
